import AdminCrudPage from "./AdminCrudPage";

export default function AdminGallery() {
  return (
    <AdminCrudPage
      title="Gallery"
      endpoint="gallery"
      initial={{ title: "", category: "Machinery", image_url: "", description: "" }}
      columns={[
        { key: "title", label: "Title" },
        { key: "category", label: "Category" },
        { key: "image_url", label: "Image", render: (it) => it.image_url ? <img src={it.image_url} alt="" className="w-12 h-12 object-cover" /> : "—" },
      ]}
      fields={[
        { name: "title", label: "Title" },
        { name: "category", label: "Category (e.g. Machinery, Project, Delivery, Service, Showroom)" },
        { name: "image_url", label: "Image", type: "image" },
        { name: "description", label: "Description", type: "textarea", rows: 2 },
      ]}
    />
  );
}
